import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

export const useExpenseTypes = () => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'expenseTypes',
    gqlEntityKey: 'expense_types',
    queryName: 'GET_EXPENSE_TYPES_QUERY',
    createMutation: 'CREATE_EXPENSE_TYPE_MUTATION',
    updateMutation: 'UPDATE_EXPENSE_TYPE_MUTATION',
    deleteMutation: 'DELETE_EXPENSE_TYPE_MUTATION',
    updateVariableName: 'set',
    transformData: (expenseType) => ({
      ...expenseType,
      company_name: expenseType.company?.name || `Company ${expenseType.company_id}`,
      expense_type_name: expenseType.expense_type_name,
      expense_type_description: expenseType.expense_type_description,
      expense_type_status: expenseType.expense_type_status ? 'active' : 'inactive',
      companyId: expenseType.company_id,
    }),
    transformFormData: (formData) => ({
      expense_type_name: formData.expense_type_name,
      expense_type_description: formData.expense_type_description || null,
      expense_type_status: formData.expense_type_status === 'active',
      company_id: formData.companyId,
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

